
import {
    DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";
import * as actions from "../../../../Config/ApiUrl";
import { isNull } from "lodash";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export const ConfirmationClassTableSchema = {
    components: {  },

    data() { 
        return {
            DATATABLE_EXPORT,
            deleteLoader: false,
            selectedUrl: "",
            Endpoint:  "transaction/invoice-approval/getClassConfirmation" ,
            tableId: "invoice-approval-confirmation-class-table",
            rowData: {},
            tableColumns: [
                {
                    title: "Product Name",
                    type: "custom-html",
                    key: "product_id",
                    modifier: (value) => {
                        return isNull(value) ? "" : value.name;
                    },
                },
                {
                    title: "Package Name",
                    type: "text",
                    key: "package_name"
                },
                {
                    title: "Monday",
                    type: "custom-html",
                    key: "time_start_1", 
                    modifier: (value, row) => {
                        const start = row.time_start_1 ? row.time_start_1.slice(0, 5) : "";
                        const end = row.time_end_1 ? row.time_end_1.slice(0, 5) : "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Tuesday",
                    type: "custom-html",
                    key: "time_start_2", 
                    modifier: (value, row) => {
                        const start = row.time_start_2 ? row.time_start_2.slice(0, 5) : "";
                        const end = row.time_end_2 ? row.time_end_2.slice(0, 5) : "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Wednesday",
                    type: "custom-html",
                    key: "time_start_3", 
                    modifier: (value, row) => {
                        const start = row.time_start_3 ? row.time_start_3.slice(0, 5) : "";
                        const end = row.time_end_3 ? row.time_end_3.slice(0, 5) : "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Thursday",
                    type: "custom-html",
                    key: "time_start_3", 
                    modifier: (value, row) => {
                        const start = row.time_start_4 ? row.time_start_4.slice(0, 5) : "";
                        const end = row.time_end_4 ? row.time_end_4.slice(0, 5) : "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Friday",
                    type: "custom-html",
                    key: "time_start_5", 
                    modifier: (value, row) => {
                        const start = row.time_start_5 ? row.time_start_5.slice(0, 5) : "";
                        const end = row.time_end_5 ? row.time_end_5.slice(0, 5) : "";
                        return `${start} - ${end}`;
                    },
                },
                {
                    title: "Start Date",
                    type: "custom-html",
                    key: "invoice_id_two", // ini tetap ambil root key invoice_id_two
                    modifier: (invoice) => {
                        if (!invoice || !invoice.academic_calendar) return "";
                        return invoice.academic_calendar.date_start;
                    },
                }
            ],
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "ConfirmationClassTable",
                url: "transaction/invoice-approval/getClassConfirmation?placement_id=" + this.placementId,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                ],
                showFilter: false,
                showSearch: false,
                showCount: false,
                showClearFilter: false,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 20,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {},
};
